import { useBreakpointValue } from '@chakra-ui/react'
import { useSetRecoilState } from 'recoil'

import { lightboxImageModalState } from 'src/atoms/ui.atom'

const SM_HEIGHT = 179
const MD_LG_HEIGHT = 246
const TITLE_HEIGHT = 38

export default function useImageCard(imageUrl: string, title?: string) {
  const setLightboxModalState = useSetRecoilState(lightboxImageModalState)
  const imageHeightBase = useBreakpointValue({
    sm: SM_HEIGHT,
    md: MD_LG_HEIGHT,
  })
  const imageHeight = imageHeightBase + (title ? 0 : TITLE_HEIGHT)
  const containerHeight = imageHeightBase + TITLE_HEIGHT
  const openImage = () => {
    setLightboxModalState({
      image: {
        src: imageUrl,
        alt: title || 'ItList image item',
      },
      isOpen: true,
    })
  }

  return { imageHeight, containerHeight, openImage }
}
